const OrdersIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 32 32"
			fill="var(--icons)"
			height="30px"
			width="30px"
		>
			<path d="M26 8h-4V6c0-2.21-1.79-4-4-4h-4c-2.21 0-4 1.79-4 4v2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 6c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2h-8V6zm14 20H6V10h4v2c0 .55.45 1 1 1s1-.45 1-1v-2h8v2c0 .55.45 1 1 1s1-.45 1-1v-2h4v16z" />
			<path d="M20.29 16.29l-5.29 5.3-2.29-2.3c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29l6-6c.39-.39.39-1.02 0-1.41s-1.03-.39-1.43 0z" />
		</svg>
	);
};
 
export default OrdersIcon;
